// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f90312d","239":"73850b33","553":"0caabd86"}[chunkId] + ".chunk.js";
};